import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Loader2, Users } from '@digital-twins/design-system/icons'
import { toast } from 'sonner'
import { Button } from '@/components/ui/button'
import { useRouter } from '@/routing/navigation'
import { ROUTES } from '@/routes/routes'
import { defaultContentLanguageFromUi } from '@/i18n'
import { libraryAudiencesApi } from '@/lib/api/library-audiences'
import type { DatasetSimulateAudienceProps } from '@/types/components/library/dataset-simulate-audience'

function SimulateAudienceButton({ documentToken }: Pick<DatasetSimulateAudienceProps, 'documentToken'>) {
  const { t, i18n } = useTranslation('app')
  const router = useRouter()
  const [starting, setStarting] = useState(false)
  const startImport = async () => {
    if (starting) return
    setStarting(true)
    try {
      const { sessionId } = await libraryAudiencesApi.createImportFromDocument(documentToken, defaultContentLanguageFromUi(i18n.language))
      router.push(ROUTES.audienceImport(sessionId))
    } catch {
      toast.error(t('library.dataset.simulateFailed'))
      setStarting(false)
    }
  }
  return (
    <Button type="button" variant="outline" size="sm" disabled={starting} onClick={startImport}
      data-testid="dataset-simulate-audience" className="gap-1.5">
      {starting ? <Loader2 className="h-4 w-4 animate-spin motion-reduce:animate-none" aria-hidden="true" /> : <Users className="h-4 w-4" aria-hidden="true" />}
      {t(starting ? 'library.dataset.simulateStarting' : 'library.dataset.simulateAudience')}
    </Button>
  )
}

export function DatasetSimulateAudience(props: DatasetSimulateAudienceProps) {
  return props.dataset.state === 'listed' && props.dataset.isRespondentLevel && !props.dataset.audience
    ? <SimulateAudienceButton documentToken={props.documentToken} /> : null
}
